module.exports = __webpack_public_path__ + "static/img/doe-logo.2222d19.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/doe-logo.png
// module id = S/y4
// module chunks = 1